const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#BB83FF",
    style: {
      fill: "#BB83FF",
      fill: "color(display-p3 0.7325 0.5136 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8327 16.167H17.8327C17.3907 16.167 16.9667 16.3426 16.6542 16.6551C16.3416 16.9677 16.166 17.3916 16.166 17.8337C16.166 18.2757 16.3416 18.6996 16.6542 19.0122C16.9667 19.3247 17.3907 19.5003 17.8327 19.5003H21.166C21.608 19.5003 22.032 19.6759 22.3445 19.9885C22.6571 20.301 22.8327 20.725 22.8327 21.167C22.8327 21.609 22.6571 22.0329 22.3445 22.3455C22.032 22.6581 21.608 22.8337 21.166 22.8337H16.166M19.4993 24.5003V14.5003M27.8327 19.5003C27.8327 24.1027 24.1017 27.8337 19.4993 27.8337C14.897 27.8337 11.166 24.1027 11.166 19.5003C11.166 14.898 14.897 11.167 19.4993 11.167C24.1017 11.167 27.8327 14.898 27.8327 19.5003Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceEdit);
export default __webpack_public_path__ + "static/media/price_edit.3ff12dbdd5dd6438e7d66ac06bfb164b.svg";
export { ForwardRef as ReactComponent };